const state = () => {
  return {
    breadcrumb: [
      {
        link: null,
        name: null,
        title: null,
        active: false
      },
      {
        link: null,
        name: null,
        title: null,
        active: false
      },
      {
        link: null,
        name: null,
        title: null,
        active: false
      }
      // {
      //   link: '',
      //   title: 'Dashboard',
      //   active: true
      // }
    ]
  }
}

const mutations = {
  crumbOne(state, data) {
    state.breadcrumb[0] = data
  },
  crumbTwo(state, data) {
    state.breadcrumb[1] = data
  },
  crumbThree(state, data) {
    state.breadcrumb[2] = data
  }
}

const actions = {
  crumbOne({ commit }, payload) {
    commit('crumbOne', payload)
  },
  crumbTwo({ commit }, payload) {
    commit('crumbTwo', payload)
  },
  crumbThree({ commit }, payload) {
    commit('crumbThree', payload)
  }
}

const getters = {
  breadcrumbs: state => state.breadcrumb
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
